import debounce from 'lodash/debounce';

import { setInitialLocation } from './location-page.autocomplete-utils';

const mapCities = (cities, group = null) => {
  return cities.map(location => {
    location.data.group = group;
    location.data.label = location.value;
    return location;
  });
};

const getLocations = () => {
  return window.__TGV_SEARCH__LOCATIONS_GROUPED.reduce((mem, el) => {
    const cities = mapCities(el.locations, el.value);

    mem.push(...cities);
    return mem;
  }, []);
};

const textEscape = (data) => {
  const div = document.createElement('div');
  div.innerText = data;
  return div.innerHTML;
};

export const initLocationAutocomplete = ({
  selector = '.js-location-autocomplete',
  errorSelector = '.js-location-error-msg',
  useInitialLocation = true,
  onUnknownLocation = () => {},
  onSelectCallback = () => {},
} = {}) => {
  const $input = $(selector);
  if ($input.length === 0) {
    return null;
  }
  const $error = $(errorSelector);

  let initialLocation;

  const showError = () => {
    $error.show();
  };

  const hideError = () => {
    $error.hide();
  };

  const resetInitialLocation = () => {
    initialLocation = null;
  };

  const getSelection = () => {
    if (initialLocation) {
      return initialLocation;
    }

    return $($input).autocomplete().selection;
  };

  let showAllSuggestions = false;
  $input.on('focus', () => {
    showAllSuggestions = true;
  });

  const locationUnknownWarningEvent = debounce((text) => {
    onUnknownLocation(text);
  }, 500);

  $input.autocomplete({
    lookup: getLocations(),
    onSearchComplete(text, results) {
      showAllSuggestions = false;

      if (!results.length) {
        locationUnknownWarningEvent(text);
      }
    },
    lookupFilter(suggestion, originalQuery, queryLowerCase) {
      // if clicked with initial value set show all results
      if (showAllSuggestions) {
        return true;
      }

      resetInitialLocation();

      const re = new RegExp(`\\b${$.Autocomplete.utils.escapeRegExChars(queryLowerCase)}`, 'gi');
      return re.test(suggestion.value);
    },
    groupBy: 'group',
    autoSelectFirst: true,
    triggerSelectOnValidInput: false,
    showNoSuggestionNotice: true,
    minChars: 0,
    noSuggestionNotice: '<span>Tagvenue is not yet available in this city</span>',
    formatResult(suggestion) {
      return textEscape(suggestion.value);
    },
    onSelect(data) {
      resetInitialLocation();
      hideError();
      onSelectCallback(data);
    },
  });

  $input.data('getSelection', getSelection);

  if (useInitialLocation) {
    setInitialLocation($input).then(data => {
      initialLocation = data;
    });
  }

  return {
    validateIsEmpty() {
      if (!getSelection()) {
        showError();
      } else {
        hideError();
      }
    },
    isValid() {
      return !!getSelection();
    },
  };
};

export const init = () => {
  return initLocationAutocomplete({
    onUnknownLocation(text) {
      App.track.event('location_page_interaction', {
        section: 'header',
        element: 'location_unknown_warning',
        element_value: text,
        interaction: 'visible',
      });
    },
    onSelectCallback(data) {
      App.track.event('location_page_interaction', {
        section: 'header',
        element: 'location',
        element_value: data.value,
        interaction: 'change',
      });
    },
  });
};
